<template>
  <van-notice-bar
    wrapable
    :scrollable="false"
    color="#484848"
    background="#F1F1F1"
    left-icon="records"
  >
  </van-notice-bar>
  <van-cell-group>
    <p class="text3Indentation">
      <van-steps :active="activeAll">
        <van-step>机构邀请</van-step>
        <van-step>个人信息</van-step>
        <van-step>补充调研</van-step>
      </van-steps>
    </p>
  </van-cell-group>
  <br />
  <van-form @submit="onSubmit">
    <van-space direction="vertical" size="2rem" fill>
      <van-row>
        <van-col offset="0.5" span="24">
          <van-cell-group inset>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （1）、您的年龄是否大于40周岁？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="userRiskInfoVo.yearOld"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （2）、您的性别是？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="userRiskInfoVo.gender"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">男</van-radio>
                <van-radio name="2" icon-size="24px">女</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （3）、您是否是吸烟者？(每周吸烟)
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="userRiskInfoVo.smoking"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （4）、您的父母55岁之前是否患有冠心病？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="userRiskInfoVo.yichuan"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （5）、您是否患有糖尿病？
            </van-notice-bar>
            <van-cell>
              <van-radio-group
                v-model="userRiskInfoVo.diabetes"
                direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （6）、您是否已经服用降压药(西药)？
            </van-notice-bar>
            <van-cell>
              <van-radio-group v-model="userRiskInfoVo.xueyayao"  direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false">
              （7）、您是否已经服用降脂药(西药)？
            </van-notice-bar>
            <van-cell>
              <van-radio-group v-model="userRiskInfoVo.xuezhiyao"  direction="horizontal">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
          </van-cell-group>
        </van-col>
      </van-row>
    </van-space>
    <div style="margin: 16px">
      <van-button
        color="linear-gradient(to right, #f67f34, #d55809)"
        round
        block
        native-type="submit"
        @click="getQueSave">提交绑定审核</van-button>
    </div>
  </van-form>
</template>
<script>
import { ref, toRefs,reactive, onMounted } from "vue";
import { postUserRiskInfo } from "../../api/queInfo";
import { showDialog } from "vant";
import { useRouter } from "vue-router";
export default {
  setup() {
    const activeAll = ref(2);
    const router = useRouter();
    const currentDate = ref(['1975', '01']);
    const result = ref(['']);
    const showPicker = ref(false);
    const columnsType = ['year', 'month'];
    const onConfirm = ({ selectedValues }) => {
      result.value = selectedValues.join('/');
      showPicker.value = false;
    };
    const question = reactive({
      userRiskInfoVo: {
        smoking: "",
        diabetes: "",
        yichuan: "",
        xuezhiyao: "",
        xueyayao: "",
        gender:"",
        birthday:"",
        yearOld:"",
      },
    });
    const themeVars = reactive({
      fontSizeMd: 32,
    });
    const getQueSave = () => {
      console.log(question.userRiskInfoVo.diabetes);
      if(question.userRiskInfoVo.diabetes == "" ||
        question.userRiskInfoVo.smoking == "" ||
        question.userRiskInfoVo.yichuan == "" ||
        question.userRiskInfoVo.xuezhiyao == "" ||
        question.userRiskInfoVo.xueyayao == "" ||
        question.userRiskInfoVo.gender == "" ||
        question.userRiskInfoVo.yearOld == ""  ){
          showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      }else{
        //console.log(result);
        //question.userRiskInfoVo.birthday=result.value;
        postUserRiskInfo(question.userRiskInfoVo).then((res) => {
          console.log(question.userRiskInfoVo);
          console.log(res.data.code);
          if (res.data.code == 0) {
            console.log("绑定成功");
            showDialog({
                title: "完成提交",
                theme: "round-button",
          }).then(() => {
            router.push('bindingHosp');
          });
          } else {
            console.log("绑定失败，失败原因:" + res.data.message);
          }
        });
      }
    };

    onMounted(() => {
    });
   
    return {
      activeAll,
      themeVars,
      getQueSave,
      result,
      onConfirm,
      showPicker,
      currentDate,
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2010, 0, 1),
      columnsType,
      ...toRefs(question),
    };
  },
};
</script>
<style lang="less" scoped>
/* 去除单元格cell下边框 */
.van-cell:after {
  border-bottom: none !important;
  border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
  color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
  color: #000;
  font-weight: 500;
}

.textIndentation {
  font-size: 12px;
  text-align: left;
}
.text2DIndentation {
  font-size: 14px;
  text-align: left;
  padding-right: 1em;
  padding-left: 1em;
}
#level {
  height: 600px;
  width: 100%;
}
#level1 {
  height: 600px;
  width: 100%;
}
#level2 {
  height: 600px;
  width: 100%;
}
.text3Indentation {
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}
</style>
